package com.kinoshazam.di

import com.kinoshazam.ComposeNavigator
import com.kinoshazam.Navigator
import org.koin.core.module.Module
import org.koin.dsl.module

fun navigationModule(): Module = module {
    single<Navigator> { ComposeNavigator() }
}